var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMessageSyncEmpty24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.262,16a7.921,7.921,0,0,0,.817,2H6L2,22V4A2.006,2.006,0,0,1,4,2H20a2.006,2.006,0,0,1,2,2V7.079a7.921,7.921,0,0,0-2-.817V4H4V18l2-2ZM18,17a3,3,0,0,1-3-3,2.965,2.965,0,0,1,.446-1.554l-1.434-1.434A4.979,4.979,0,0,0,18,19v2l3-3-3-3Zm0-8V7l-3,3,3,3V11a3,3,0,0,1,3,3,2.965,2.965,0,0,1-.446,1.554l1.434,1.434A4.979,4.979,0,0,0,18,9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}
export default __webpack_public_path__ + "media/ic_message_sync_empty_24dp.svg";
export { SvgIcMessageSyncEmpty24Dp as ReactComponent };